module.exports = __webpack_public_path__ + "media/src/images/icons/refresh-951b9d3d54be3e4384595d3906c15b68.svg";